<!-- Header -->
<!-- <div mat-dialog-title translate>Report Auto-Run Settings</div> -->

<!-- Content -->
<form #autorunForm="ngForm" id="autorunForm">
    <mat-dialog-content>



        <!-- Auto-Run Settings -->
        <div *ngIf="allowAutoRunReport">
            <div style=padding-top:20px;></div>
            <table style="width:95%; margin-left:10px;">
                <tr>
                    <td colspan="2">

                        <div [ngStyle]="{color: allowAutoRunReport ? 'black' : 'lightgray'}">
                            Maximum Snapshots is set to {{maxReportSnapshotAllowed}}
                        </div>
                    </td>
                </tr>

                <!-- ONCE A WEEK-->
                <tr [ngStyle]="{color: selectedReport.AutoRunReport == false ? 'lightgray' : 'black'}">
                    <td align="center">
                        <input type="radio" name="frequency" [checked]="selectedReport.AutoRunFrequency == 0" (click)="setFrequency(0)" />
                        Once a Week
                    </td>
                </tr>
                <tr *ngIf="selectedReport.AutoRunFrequency == 0 && selectedReport.AutoRunReport">
                    <td>

                        <tyl-form-field label="Day">

                            <mat-select id="ddlAutoRunDay" name="ddlAutoRunDay" [(ngModel)]="selectedReport.AutoRunDay"
                                [(value)]="selectedReport.AutoRunDay" [disabled]="selectedReport.AutoRunFrequency != 0 || !selectedReport.AutoRunReport"
                                [required]="selectedReport.AutoRunReport && selectedReport.AutoRunFrequency == 0">
                                <mat-option value="MON">Monday</mat-option>
                                <mat-option value="TUE">Tuesday</mat-option>
                                <mat-option value="WED">Wednesday</mat-option>
                                <mat-option value="THU">Thursday</mat-option>
                                <mat-option value="FRI">Friday</mat-option>
                                <mat-option value="SAT">Saturday</mat-option>
                                <mat-option value="SUN">Sunday</mat-option>
                            </mat-select>

                        </tyl-form-field>
                    </td>



                    <td style = "float: left; padding-right: 5px">

                        <tyl-form-field label="Hour" style='width: 100px'>

                            <mat-select id="ddlAutoRunHour" name="ddlAutoRunHour" [(ngModel)]="AutoRunHour_0" [(value)]="AutoRunHour_0"
                                [required]="selectedReport.AutoRunReport " [disabled]="!selectedReport.AutoRunReport">
                                <mat-option value="01">01</mat-option>
                                <mat-option value="02">02</mat-option>
                                <mat-option value="03">03</mat-option>
                                <mat-option value="04">04</mat-option>
                                <mat-option value="05">05</mat-option>
                                <mat-option value="06">06</mat-option>
                                <mat-option value="07">07</mat-option>
                                <mat-option value="08">08</mat-option>
                                <mat-option value="09">09</mat-option>
                                <mat-option value="10">10</mat-option>
                                <mat-option value="11">11</mat-option>
                                <mat-option value="12">12</mat-option>
                            </mat-select>

                        </tyl-form-field>
                    </td>

                    <td style = "float: left; padding-right: 5px"> 

                        <tyl-form-field label="Minute" style='width: 100px'>

                            <mat-select id="ddlAutoRunMinute" name="ddlAutoRunMinute" [(ngModel)]="AutoRunMinute_0"
                                [(value)]="AutoRunMinute_0" [required]="selectedReport.AutoRunReport " [disabled]="!selectedReport.AutoRunReport">
                                <mat-option value="00">00</mat-option>
                                <mat-option value="05">05</mat-option>
                                <mat-option value="10">10</mat-option>
                                <mat-option value="15">15</mat-option>
                                <mat-option value="20">20</mat-option>
                                <mat-option value="25">25</mat-option>
                                <mat-option value="30">30</mat-option>
                                <mat-option value="35">35</mat-option>
                                <mat-option value="40">40</mat-option>
                                <mat-option value="45">45</mat-option>
                                <mat-option value="50">50</mat-option>
                                <mat-option value="55">55</mat-option>
                            </mat-select>

                        </tyl-form-field>
                    </td>

                    <td style = "float: left; padding-right: 5px">

                        <tyl-form-field label="Period" style='width: 100px'>

                            <mat-select id="ddlAutoRunPeriod" name="ddlAutoRunPeriod" [(ngModel)]="AutoRunPeriod_0"
                                [(value)]="AutoRunPeriod_0" [required]="selectedReport.AutoRunReport" [disabled]="!selectedReport.AutoRunReport">
                                <mat-option value="AM">AM</mat-option>
                                <mat-option value="PM">PM</mat-option>

                            </mat-select>

                        </tyl-form-field>
                    </td>
                    <!-- <ReportTimePicker id='TimePicker1'></ReportTimePicker> -->

                    <!-- <tyl-form-field label="Time">

                        <input matInput [(ngModel)]="selectedReport.AutoRunTime" placeholder="hh:mm" [disabled]="selectedReport.AutoRunFrequency != 0 || !selectedReport.AutoRunReport"
                            [required]="selectedReport.AutoRunReport && selectedReport.AutoRunFrequency == 0" />

                    </tyl-form-field> -->


                </tr>


                <!-- ONCE A DAY-->
                <tr [ngStyle]="{color: selectedReport.AutoRunReport == false ? 'lightgray' : 'black'}">
                    <td align="center">
                        <input type="radio" name="frequency" [disabled]="!selectedReport.AutoRunReport" [checked]="selectedReport.AutoRunFrequency == 1"
                            (click)="setFrequency(1)" />
                        Once a Day
                    </td>
                </tr>
                <tr *ngIf="selectedReport.AutoRunFrequency == 1 && selectedReport.AutoRunReport">

                    <td style = "float: left; padding-right: 5px">

                        <tyl-form-field label="Hour" style='width: 100px'>

                            <mat-select id="ddlAutoRunHour" name="ddlAutoRunHour" [(ngModel)]="AutoRunHour_1" [(value)]="AutoRunHour_1"
                                [required]="selectedReport.AutoRunReport" [disabled]="!selectedReport.AutoRunReport">
                                <mat-option value="01">01</mat-option>
                                <mat-option value="02">02</mat-option>
                                <mat-option value="03">03</mat-option>
                                <mat-option value="04">04</mat-option>
                                <mat-option value="05">05</mat-option>
                                <mat-option value="06">06</mat-option>
                                <mat-option value="07">07</mat-option>
                                <mat-option value="08">08</mat-option>
                                <mat-option value="09">09</mat-option>
                                <mat-option value="10">10</mat-option>
                                <mat-option value="11">11</mat-option>
                                <mat-option value="12">12</mat-option>
                            </mat-select>

                        </tyl-form-field>
                    </td>

                    <td style = "float: left; padding-right: 5px">

                        <tyl-form-field label="Minute" style='width: 100px'>

                            <mat-select id="ddlAutoRunMinute" name="ddlAutoRunMinute" [(ngModel)]="AutoRunMinute_1"
                                [(value)]="AutoRunMinute_1" [required]="selectedReport.AutoRunReport" [disabled]="!selectedReport.AutoRunReport">
                                <mat-option value="00">00</mat-option>
                                <mat-option value="05">05</mat-option>
                                <mat-option value="10">10</mat-option>
                                <mat-option value="15">15</mat-option>
                                <mat-option value="20">20</mat-option>
                                <mat-option value="25">25</mat-option>
                                <mat-option value="30">30</mat-option>
                                <mat-option value="35">35</mat-option>
                                <mat-option value="40">40</mat-option>
                                <mat-option value="45">45</mat-option>
                                <mat-option value="50">50</mat-option>
                                <mat-option value="55">55</mat-option>
                            </mat-select>

                        </tyl-form-field>
                    </td>

                    <td style = "float: left; padding-right: 5px">

                        <tyl-form-field label="Period" style='width: 100px'>

                            <mat-select id="ddlAutoRunPeriod" name="ddlAutoRunPeriod" [(ngModel)]="AutoRunPeriod_1"
                                [(value)]="AutoRunPeriod_1" [required]="selectedReport.AutoRunReport" [disabled]="!selectedReport.AutoRunReport">
                                <mat-option value="AM">AM</mat-option>
                                <mat-option value="PM">PM</mat-option>

                            </mat-select>

                        </tyl-form-field>
                    </td>
                    <!-- <ReportTimePicker id='TimePicker2'></ReportTimePicker> -->

                    <!-- <tyl-form-field label="Time">
                        <input matInput [(ngModel)]="selectedReport.AutoRunTime" placeholder="hh:mm" [disabled]="selectedReport.AutoRunFrequency != 1"
                            [required]="selectedReport.AutoRunReport && selectedReport.AutoRunFrequency == 1" />
                    </tyl-form-field> -->

                </tr>


                <!-- ONCE ONLY-->
                <tr [ngStyle]="{color: selectedReport.AutoRunReport == false ? 'lightgray' : 'black'}">
                    <td align="center">
                        <input type="radio" name="frequency" [disabled]="!selectedReport.AutoRunReport" [checked]="selectedReport.AutoRunFrequency == 2"
                            (click)="setFrequency(2)" />
                        Once Only
                    </td>
                </tr>
                <tr *ngIf="selectedReport.AutoRunFrequency == 2 && selectedReport.AutoRunReport">
                    <td>
                        <ng-container style="display:inline;">
                            <tyl-datepicker label="Date" id="OnceDatePicker" [(value)]="selectedReport.AutoRunDate"
                                [disabled]="selectedReport.AutoRunFrequency != 2" [isRequired]="selectedReport.AutoRunReport">
                            </tyl-datepicker>
                        </ng-container>


                    </td>

                    <td style = "float: left; padding-right: 5px">

                        <tyl-form-field label="Hour" style='width: 100px'>

                            <mat-select id="ddlAutoRunHour" name="ddlAutoRunHour" [(ngModel)]="AutoRunHour_2" [(value)]="AutoRunHour_2"
                                [required]="selectedReport.AutoRunReport ">
                                <mat-option value="01">01</mat-option>
                                <mat-option value="02">02</mat-option>
                                <mat-option value="03">03</mat-option>
                                <mat-option value="04">04</mat-option>
                                <mat-option value="05">05</mat-option>
                                <mat-option value="06">06</mat-option>
                                <mat-option value="07">07</mat-option>
                                <mat-option value="08">08</mat-option>
                                <mat-option value="09">09</mat-option>
                                <mat-option value="10">10</mat-option>
                                <mat-option value="11">11</mat-option>
                                <mat-option value="12">12</mat-option>
                            </mat-select>

                        </tyl-form-field>
                    </td>

                    <td style = "float: left; padding-right: 5px">

                        <tyl-form-field label="Minute" style='width: 100px'>

                            <mat-select id="ddlAutoRunMinute" name="ddlAutoRunMinute" [(ngModel)]="AutoRunMinute_2"
                                [(value)]="AutoRunMinute_2" [required]="selectedReport.AutoRunReport ">
                                <mat-option value="00">00</mat-option>
                                <mat-option value="05">05</mat-option>
                                <mat-option value="10">10</mat-option>
                                <mat-option value="15">15</mat-option>
                                <mat-option value="20">20</mat-option>
                                <mat-option value="25">25</mat-option>
                                <mat-option value="30">30</mat-option>
                                <mat-option value="35">35</mat-option>
                                <mat-option value="40">40</mat-option>
                                <mat-option value="45">45</mat-option>
                                <mat-option value="50">50</mat-option>
                                <mat-option value="55">55</mat-option>
                            </mat-select>

                        </tyl-form-field>
                    </td>

                    <td style = "float: left; padding-right: 5px">

                        <tyl-form-field label="Period" style='width: 100px'>

                            <mat-select id="ddlAutoRunPeriod" name="ddlAutoRunPeriod" [(ngModel)]="AutoRunPeriod_2"
                                [(value)]="AutoRunPeriod_2" [required]="selectedReport.AutoRunReport">
                                <mat-option value="AM">AM</mat-option>
                                <mat-option value="PM">PM</mat-option>

                            </mat-select>

                        </tyl-form-field>
                    </td>
                    <!-- <ReportTimePicker id='TimePicker3'></ReportTimePicker> -->

                    <!-- <tyl-form-field label="Time">

                        <input matInput [(ngModel)]="selectedReport.AutoRunTime" placeholder="hh:mm" [disabled]=" selectedReport.AutoRunFrequency != 2"
                            [required]="selectedReport.AutoRunReport && selectedReport.AutoRunFrequency == 2" />

                    </tyl-form-field> -->


                </tr>

                <!-- <tr [ngStyle]="{color: selectedReport.AutoRunReport == false ? 'lightgray' : 'black'}">
                <td colspan="2">
                    <a style="font-size:10pt;cursor:pointer;" (click)="openAutorunDefaultParametersDialog()">
                        <span>Select Autorun Default Parameters</span>
                    </a>
                </td>
            </tr> -->
            </table>

            <!-- <reportParameters></reportParameters> -->
        </div>

    </mat-dialog-content>
    <input type="submit" form="autorunForm" style="display: none" #validationTrigger>
</form>
<!-- Footer -->
<!-- <mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button *ngIf="this.inDebugMode" style="float:right; color: black;" image="next arrow.png" label="Selected Report To Console"
            (clickEvent)="SelectedReportToConsole()"></tyl-button>
        <tyl-button style="float:right; color: black;" image="cancel.png" translate label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
        <tyl-button style="float:right; color: black;" image="post.png" translate label="Save" (clickEvent)="saveClick()"></tyl-button>
    </div>
</mat-dialog-actions> -->